<div class="page-header">
  <app-page-title></app-page-title>
</div>
<div class="user-business-container">
  <div class="search-section">
    <div class="search-row row g-2 g-md-3 align-items-center">
      <div class="col-12 col-md order-2 order-md-1">
        <div class="search-wrapper">
          <i class="bi bi-search search-icon" aria-hidden="true"></i>
          <label class="visually-hidden" for="search-input">ค้นหาธุรกิจ</label>
          <input id="search-input"
                 type="text"
                 class="form-control"
                 placeholder="ค้นหา"
                 [ngModel]="searchTerm()"
                 (ngModelChange)="onSearchTermChange($event)"
                 (keyup.enter)="searchBusiness()">
          @if (searchTerm()) {
            <button type="button" class="search-clear" aria-label="ล้างการค้นหา" (click)="clearSearch()">
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          }
        </div>
      </div>
      @if (!actingFor()) {
        <div class="col-12 col-md-auto order-1 order-md-2">
          <button type="button" class="btn btn-primary w-100 w-md-auto" (click)="openAddModal()">
            <i class="bi bi-plus-lg" aria-hidden="true"></i>
            เพิ่มธุรกิจ
          </button>
        </div>
      }
    </div>
  </div>

  @if (actingFor()) {
    <div class="acting-notice" role="status" id="business-acting-notice">
      <i class="bi bi-person-badge" aria-hidden="true"></i>
      <span>
        กำลังดูธุรกิจของ <strong>{{ actingForName() }}</strong> ในฐานะผู้ดำเนินการแทน — ดูได้อย่างเดียว
        หากต้องการจัดการธุรกิจของคุณเอง ให้สลับกลับเป็นบัญชีของคุณก่อน
      </span>
    </div>
  }

  <div class="business-filter-row">
    <p class="result-count" aria-live="polite">พบ <strong>{{ businesses().length }}</strong> ธุรกิจ</p>
    <div class="status-filters" role="group" aria-label="กรองข้อมูลธุรกิจ">
      @for (filter of filterOptions; track filter.value) {
        @if (filter.value !== 'inactive' || countForFilter('inactive') > 0) {
          <button type="button"
                  class="filter-pill"
                  [class.is-selected]="statusFilter() === filter.value"
                  [class.filter-pill-active]="filter.value === 'active'"
                  [class.filter-pill-inactive]="filter.value === 'inactive'"
                  [class.filter-pill-juristic]="filter.value === 'juristic'"
                  [attr.aria-pressed]="statusFilter() === filter.value"
                  (click)="setFilter(filter.value)">
            <span>{{ filter.label }}</span>
            <span class="filter-count">{{ countForFilter(filter.value) }}</span>
          </button>
        }
      }
    </div>
  </div>

  @if (isLoading()) {
    <div class="empty-state mt-3">
      <div class="empty-icon">
        <div class="spinner-border text-success" role="status" aria-label="กำลังโหลด"></div>
      </div>
      <h2>กำลังโหลดข้อมูลธุรกิจ</h2>
    </div>
  } @else if (allBusinesses().length === 0) {
    <div class="empty-state">
      <div class="empty-icon">
        <i class="bi bi-inbox" aria-hidden="true"></i>
      </div>
      <h2>ไม่พบข้อมูลธุรกิจ</h2>
      @if (actingFor()) {
        <p>{{ actingForName() }} ยังไม่ได้มอบสิทธิ์ธุรกิจใดให้คุณ</p>
      } @else {
        <p>ยังไม่มีข้อมูลธุรกิจในระบบ</p>
        <button type="button" class="btn btn-primary" (click)="openAddModal()">
          <i class="bi bi-plus-lg" aria-hidden="true"></i>
          เพิ่มธุรกิจแรก
        </button>
      }
    </div>
  } @else if (businesses().length === 0) {
    <div class="empty-state filtered-empty-state">
      <div class="empty-icon">
        <i class="bi bi-funnel" aria-hidden="true"></i>
      </div>
      <h2>ไม่พบธุรกิจที่ตรงกับตัวกรอง</h2>
      <p>ลองเปลี่ยนคำค้นหาหรือเลือกตัวกรองอื่น</p>
      <button type="button" class="filter-reset-button" (click)="clearFilters()">ล้างตัวกรอง</button>
    </div>
  } @else {
    <section class="business-card-list" aria-label="รายการธุรกิจ">
      @for (business of businesses(); track business.id) {
        <article class="business-card">
          <div class="business-card-body">
            <div class="business-item">
              <div class="business-avatar" aria-hidden="true">
                @if (hasAvatar(business)) {
                  <img [src]="business.imageUrl"
                       alt=""
                       class="avatar-img"
                       (error)="onAvatarError(business)">
                } @else {
                  <i class="bi bi-briefcase" aria-hidden="true"></i>
                }
              </div>

              <div class="business-content">
                <div class="business-top">
                  <div class="business-title-group">
                    <h2 class="business-name">
                      <span>{{ business.name }}</span>
                      @if (business.number && business.number !== '-') {
                        <span class="business-number">— {{ business.number }}</span>
                      }
                    </h2>
                    <span class="business-subtitle">
                      @if (isJuristicBusiness(business)) {
                        <button type="button"
                                class="business-type-trigger"
                                aria-label="กรองธุรกิจประเภทนิติบุคคล"
                                (click)="setFilter('juristic')">
                          {{ business.subtitle }}
                        </button>
                      } @else {
                        {{ business.subtitle }}
                      }
                    </span>
                    @if (business.businessTypeTitles.length > 0) {
                      <div class="business-badges">
                        @for (title of business.businessTypeTitles; track title) {
                          <span class="business-badge">{{ title }}</span>
                        }
                      </div>
                    }
                  </div>

                  <div class="business-actions">
                    @if (actingFor()) {
                      <span class="acting-badge" [title]="'ดำเนินการแทน ' + actingForName()">
                        <i class="bi bi-person-badge" aria-hidden="true"></i> ดำเนินการแทน
                      </span>
                    }
                    <button type="button"
                            class="status-badge"
                            [class.status-active]="business.status === 'active'"
                            [class.status-inactive]="business.status === 'inactive'"
                            [attr.aria-label]="business.status === 'active' ? 'กรองธุรกิจที่ใช้งาน' : 'กรองธุรกิจที่ไม่ใช้งาน'"
                            (click)="setFilter(business.status)">
                      {{ business.status === 'active' ? 'ใช้งาน' : 'ไม่ใช้งาน' }}
                    </button>
                    @if (!actingFor()) {
                      <button type="button"
                              class="business-edit-button"
                              [attr.aria-label]="'แก้ไข ' + business.name"
                              title="แก้ไข"
                              (click)="openEditModal(business)">
                        <i class="bi bi-pencil" aria-hidden="true"></i>
                      </button>
                    }
                  </div>
                </div>

<!--                @if (business.address && business.address !== '-') {-->
<!--                  <div class="business-address">-->
<!--                    <i class="bi bi-geo-alt" aria-hidden="true"></i>-->
<!--                    <span>{{ business.address }}</span>-->
<!--                  </div>-->
<!--                }-->

                <div class="contact-grid">
                  <div class="contact-item">
                    <span class="contact-label">โทรศัพท์</span>
                    <span class="contact-value">{{ business.phone || '-' }}</span>
                  </div>
                  <div class="contact-item">
                    <span class="contact-label">โทรสาร</span>
                    <span class="contact-value">{{ business.fax || '-' }}</span>
                  </div>
                  <div class="contact-item">
                    <span class="contact-label">อีเมล</span>
                    <span class="contact-value">{{ business.email || '-' }}</span>
                  </div>
                  <div class="contact-item">
                    <span class="contact-label">เว็บไซต์</span>
                    <span class="contact-value">{{ business.website || '-' }}</span>
                  </div>
                </div>

                <div class="business-footer">
                  <span class="save-info">บันทึกโดย {{ business.savedBy }} | {{ business.savedDate }}</span>
                </div>
              </div>
            </div>
          </div>
        </article>
      }
    </section>
  }
</div>
